export const GET_TEMPLATE_LIST="GET_TEMPLATE_LIST";
export const ADD_TEMPLATE="ADD_TEMPLATE";
export const UPDATE_TEMPLATE="UPDATE_TEMPLATE";
export const DELETE_TEMPLATE="DELETE_TEMPLATE";
export const HIDE_LOADING="HIDE_LOADING";
export const SHOW_LOADING="SHOW_LOADING";
export const TEMPLATE_LIST="TEMPLATE_LIST";
export const SET_ADD_EDIT="SET_ADD_EDIT";
export const TEMPLATE_MESSAGE="TEMPLATE_MESSAGE";
export const GET_TEMPLATE_PAGE_DRAFT_LIST="GET_TEMPLATE_PAGE_DRAFT_LIST";
export const ADD_TEMPLATE_PAGE_DRAFT="ADD_TEMPLATE_PAGE_DRAFT";
export const UPDATE_TEMPLATE_PAGE_DRAFT="UPDATE_TEMPLATE_PAGE_DRAFT";
export const DELETE_TEMPLATE_PAGE_DRAFT="DELETE_TEMPLATE_PAGE_DRAFT";
export const TEMPLATE_PAGE_DRAFT_LIST="TEMPLATE_PAGE_DRAFT_LIST";
export const TEMPLATE_PAGE_DRAFT_MESSAGE="TEMPLATE_PAGE_DRAFT_MESSAGE";
export const TEMPLATE_PAGE_LIST="TEMPLATE_PAGE_LIST";
export const TAB_VALUE="TAB_VALUE";
export const ADD_TEMPLATE_PAGE_PUBLISH="ADD_TEMPLATE_PAGE_PUBLISH";
export const UPDATE_TEMPLATE_PAGE_PUBLISH="UPDATE_TEMPLATE_PAGE_PUBLISH";
export const GET_TEMPLATE_LIST_WITH_PAGES="GET_TEMPLATE_LIST_WITH_PAGES";
export const TEMPLATE_LIST_WITH_PAGES="TEMPLATE_LIST_WITH_PAGES";